import { useId, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { formatLessonText, remarkLessonDesign } from './formatLessonText';
import './LessonReading.css';

export const LessonSectionHeading = ({ number, tone = 'rose', children, testId, level = 'h2' }) => {
  const Heading = level;
  return <div className="lesson-section-heading" data-tone={tone}>
    <span className="lesson-section-number" aria-hidden="true">{number}</span>
    <Heading data-testid={testId}>{children}</Heading>
  </div>;
};

const components = {
  h2: ({ node, children, ...props }) => <LessonSectionHeading number={props['data-section-number']} tone={props['data-section-tone']} testId={props['data-testid']}>{children}</LessonSectionHeading>,
  a: ({ node, children, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer">{children}</a>,
  table: ({ node, children, ...props }) => <div className="lesson-reading-table" tabIndex={0} role="region" aria-label="جدول المحتوى" data-testid={`${props['data-testid']}-scroll`}><table {...props}>{children}</table></div>,
};

export const LessonTextContent = ({ content, kind, compact = false, testId = 'ai-text-content' }) => {
  const id = useId().replace(/:/g, '');
  const markdown = useMemo(() => formatLessonText(content, kind), [content, kind]);
  const plugins = useMemo(() => [remarkGfm, remarkBreaks, [remarkLessonDesign, { prefix: `lesson-reading-${id}` }]], [id]);
  return <article className={`lesson-reading${compact ? ' lesson-reading-compact' : ''}`} dir="rtl" data-testid={testId}>
    <ReactMarkdown remarkPlugins={plugins} components={components}>{markdown}</ReactMarkdown>
  </article>;
};